<template>
  <v-card>
    <div class="text-xs-right">
      <v-btn small flat fab @click="handleClose">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 sm6 class="form-control px-1" :class="{ 'has-error': errors.has('username') }">
          <div class="caption mb-1 mt-2">Username *</div>
          <input
            v-model="user.userid"
            v-validate="{
              ...(isZwizAdmin() ? {} : { regex: /^((?!zwiz).)*$/ })
            }"
            type="text"
            :placeholder="$t('Username')"
            class="form-control"
            maxlength="255"
            name="username"
            data-vv-as="Username"
            :disabled="type === 'edit'"
          />
          <p v-if="errors.has('username')" class="text-error">{{ errors.first('username') }}</p>
        </v-flex>
        <v-flex xs12 sm6 class="form-control px-1" :class="{ 'has-error': errors.has('password') }">
          <div class="caption mb-1 mt-2">Password *</div>
          <input
            v-model="user.password"
            v-validate="'required|isValidPassword'"
            type="password"
            :placeholder="$t('Password')"
            class="form-control"
            maxlength="255"
            name="password"
            data-vv-as="Password"
            :disabled="type === 'edit'"
          />
          <p v-if="errors.has('password')" class="text-error">{{ errors.first('password') }}</p>
        </v-flex>
        <v-flex xs12>
          <PasswordValidation
            v-show="!isValidPassword"
            :value="user.password || ''"
            :is-valid.sync="isValidPassword"
          />
        </v-flex>

        <v-flex
          xs12
          sm12
          class="form-control px-1 pb-2"
          :class="{ 'has-error': errors.has('group') }"
        >
          <div class="caption mb-1 mt-2">Group</div>
          <multiselect
            v-model="user.group"
            :options="agentGroup"
            track-by="groupname"
            label="groupname"
            name="group"
            :searchable="true"
            select-label
            selected-label
            deselect-label
          ></multiselect>
          <p v-if="errors.has('group')" class="text-error">{{ errors.first('group') }}</p>
        </v-flex>
      </v-layout>
      <v-divider class="my-3" />
      <div class="font-weight-bold">General Permission</div>
      <div class="caption primary--text mt-1">Note: เลือกอย่างน้อย 1 อัน</div>
      <v-layout wrap>
        <v-flex xs12>
          <v-checkbox
            v-model="general_permission.admin_user_management"
            label="จัดการแอดมิน (Admin User Management)"
            :value="true"
            hide-details
            color="primary"
          ></v-checkbox>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            v-model="general_permission.seminar_management"
            label="จัดการสัมมนา (Seminar management)"
            :value="true"
            hide-details
            color="primary"
          ></v-checkbox>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            v-model="general_permission.member_management"
            :label="$t('aira_member_management')"
            :value="true"
            hide-details
            color="primary"
          ></v-checkbox>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            v-model="general_permission.chatbot_management"
            label="จัดการแชทบอท (Chatbot Management)"
            :value="true"
            hide-details
            color="primary"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-divider class="my-3" />
      <div class="font-weight-bold">Broadcast Permission</div>
      <v-layout wrap>
        <v-flex xs12>
          <v-checkbox
            v-model="broadcast_permission.create_broadcast"
            label="การสร้างบรอดแคสต์ (Create Broadcast)"
            :value="true"
            hide-details
            color="primary"
          ></v-checkbox>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            v-model="broadcast_permission.approve_broadcast"
            label="การอนุมัติบรอดแคสต์ (Approve Broadcast)"
            :value="true"
            hide-details
            color="primary"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-divider class="my-3" />
      <div>
        <div class="font-weight-bold">View Permission หน้าสร้างบรอดแคสต์</div>
        <div class="caption primary--text mt-1">สิทธิ์ในการมองเห็นข้อมูลในการสร้างบรอดแคสต์</div>
        <div class="mt-2">
          <multiselect
            v-model="broadcast_permission.view_create_broadcast"
            :options="permissionCreateBroadcastOptions"
            label="label"
            select-label
            selected-label
            :allow-empty="false"
            :searchable="false"
            track-by="value"
            deselect-label
          ></multiselect>
        </div>
      </div>
      <div class="my-3">
        <div class="font-weight-bold">View permission หน้าการอนุมัติบรอดแคสต์</div>
        <div class="caption primary--text mt-1">
          สิทธิ์ในการมองเห็นข้อมูลในหน้าการอนุมัติบรอดแคสต์
        </div>
        <div class="mt-2">
          <multiselect
            v-model="broadcast_permission.view_approve_broadcast"
            :options="permissionApproveBroadcastOptions"
            label="label"
            select-label
            selected-label
            :allow-empty="false"
            :searchable="false"
            deselect-label
            track-by="value"
          ></multiselect>
        </div>
      </div>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="handleClose">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ManageUser from './ManageUser.js'
export default {
  mixins: [ManageUser]
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/AgentManagement/UserManageDialog.vue